import React from 'react';
import PropTypes from 'prop-types';
import { UserStore } from 'four-nets/user/user';
import { FourNetsApi } from 'four-nets/api/api';
import FetchData from 'lib/fetch-data/fetch-data';
import { PhotoFileStore } from 'four-nets/photofile/photofile';
import { SearchApi } from 'four-nets/search/search-api';

import ForumRelatedDiscussions from './forum-related-discussions';

class ForumRelatedDiscussionsLoader extends React.PureComponent {
    searchApi: SearchApi;

    static contextTypes = {
        api: PropTypes.instanceOf(FourNetsApi),
        userStore: PropTypes.instanceOf(UserStore),
    };

    static childContextTypes = {
        searchApi: PropTypes.instanceOf(SearchApi),
    };

    getChildContext() {
        return { searchApi: this.searchApi };
    }

    UNSAFE_componentWillMount() {
        const { api, userStore } = this.context;
        this.searchApi = new SearchApi({ userStore, api });
    }

    transform = data => {
        return data;
    };

    fetch = setData => {
        const { api } = this.context;
        const { query } = this.props;

        const params = {
            query,
            target: 'forum',
            searchTitlesOnly: false,
            page: 1,
        };

        let promise;
        if (query) {
            promise = this.searchApi.search({
                ...params,
                titleOnly: params.searchTitlesOnly,
                photoFileStore: new PhotoFileStore({ api }),
            });
        } else {
            promise = Promise.resolve();
        }

        return promise.then(result => setData({ result }));
    };

    renderFetch = ({ loading, error, data }) => <ForumRelatedDiscussions data={data} />;

    render() {
        return (
            <FetchData
                serializerKey={__filename}
                render={this.renderFetch}
                transform={this.transform}
                fetch={this.fetch}
                {...this.props}
            />
        );
    }
}

export default ForumRelatedDiscussionsLoader;
